var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessageEmptyWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4240_45365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9999 26.6667L31.9999 22.6667H22.6666C22.313 22.6667 21.9738 22.5262 21.7238 22.2761C21.4737 22.0261 21.3333 21.687 21.3333 21.3333V13.3333C21.3333 12.9797 21.4737 12.6406 21.7238 12.3905C21.9738 12.1405 22.313 12 22.6666 12H34.6666C35.0202 12 35.3593 12.1405 35.6094 12.3905C35.8594 12.6406 35.9999 12.9797 35.9999 13.3333V26.6667Z",
    stroke: "#ffffff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 28V30.6667C26.6667 31.0203 26.5262 31.3594 26.2761 31.6095C26.0261 31.8595 25.687 32 25.3333 32H16L12 36V22.6667C12 22.313 12.1405 21.9739 12.3905 21.7239C12.6406 21.4738 12.9797 21.3333 13.3333 21.3333H16",
    stroke: "#ffffff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4240_45365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageEmptyWhite);
export default __webpack_public_path__ + "static/media/message-emptyWhite.9e832cf2c248b41ceadd60be1c120745.svg";
export { ForwardRef as ReactComponent };